<span
  class="achCutOffMessage"
  *ngIf="cutOffTime; else no_cutOffTime"
  id="cut-off-time-text"
>
  {{ 'ARC_PAYMENT_ACH_CUTOFF_PART_1' | translate }}
  {{ cutOffTime | localDate: true | async }}
  {{ 'ARC_PAYMENT_ACH_CUTOFF_PART_2' | translate }}
</span>
<ng-template #no_cutOffTime>
  <span class="achCutOffMessage" id="no-cut-off-time-text">
    {{ 'ARC_PAYMENT_NO_ACH_CUTOFF' | translate }}
  </span></ng-template
>
